/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner } from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner';
import {
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSONTyped,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerToJSON,
    FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerToJSONTyped,
} from './FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner';

/**
 * 
 * @export
 * @interface FindHomeHealthPractitionerAssignments200ResponseData
 */
export interface FindHomeHealthPractitionerAssignments200ResponseData {
    /**
     * 
     */
    assignments: Array<FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInner>;
}

/**
 * Check if a given object implements the FindHomeHealthPractitionerAssignments200ResponseData interface.
 */
export function instanceOfFindHomeHealthPractitionerAssignments200ResponseData(value: object): value is FindHomeHealthPractitionerAssignments200ResponseData {
    if (!('assignments' in value) || value['assignments'] === undefined) return false;
    return true;
}

export function FindHomeHealthPractitionerAssignments200ResponseDataFromJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseData {
    return FindHomeHealthPractitionerAssignments200ResponseDataFromJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHomeHealthPractitionerAssignments200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'assignments': ((json['assignments'] as Array<any>).map(FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerFromJSON)),
    };
}

export function FindHomeHealthPractitionerAssignments200ResponseDataToJSON(json: any): FindHomeHealthPractitionerAssignments200ResponseData {
    return FindHomeHealthPractitionerAssignments200ResponseDataToJSONTyped(json, false);
}

export function FindHomeHealthPractitionerAssignments200ResponseDataToJSONTyped(value?: FindHomeHealthPractitionerAssignments200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignments': ((value['assignments'] as Array<any>).map(FindHomeHealthPractitionerAssignments200ResponseDataAssignmentsInnerToJSON)),
    };
}

